import React from "react";
import { Loader2 } from "lucide-react";

export function PageTitle({ eyebrow, title, sub }) {
  return (
    <div className="mb-8" data-testid="portal-page-title">
      {eyebrow && <p className="font-sans text-xs font-semibold uppercase tracking-[0.28em] text-gold-deep">{eyebrow}</p>}
      <h1 className="mt-2 font-display text-4xl font-semibold text-sapphire-deep">{title}</h1>
      {sub && <p className="mt-2 font-sans text-sm text-ink/60">{sub}</p>}
    </div>
  );
}

export function Card({ children, className = "", ...rest }) {
  return (
    <div
      className={`rounded-2xl border border-sapphire-deep/10 bg-white p-6 shadow-[0_10px_30px_-22px_rgba(10,36,99,0.4)] ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

const badgeColors = {
  Paid: "bg-emerald/12 text-emerald",
  Due: "bg-garnet/12 text-garnet",
  Active: "bg-emerald/12 text-emerald",
  "At Risk": "bg-gold/20 text-gold-deep",
  Dormant: "bg-garnet/15 text-garnet",
  new: "bg-gold/15 text-gold-deep",
  contacted: "bg-sapphire-deep/10 text-sapphire-deep",
  closed: "bg-stonegrey/15 text-stonegrey",
  "Regular Meeting": "bg-sapphire-deep/10 text-sapphire-deep",
  Installation: "bg-gold/15 text-gold-deep",
  Social: "bg-emerald/12 text-emerald",
  "Meet & Greet": "bg-emerald/12 text-emerald",
  Charity: "bg-garnet/12 text-garnet",
};

export function Badge({ children }) {
  const cls = badgeColors[children] || "bg-sapphire-deep/8 text-sapphire-deep";
  return (
    <span className={`inline-flex items-center rounded-full px-3 py-1 font-sans text-xs font-semibold uppercase tracking-wide ${cls}`}>
      {children}
    </span>
  );
}

export function Loading() {
  return (
    <div className="flex items-center justify-center py-24">
      <Loader2 className="animate-spin text-gold-deep" size={32} />
    </div>
  );
}

export function fmtDate(iso, withTime = false) {
  if (!iso) return "—";
  const d = new Date(iso);
  const opts = { day: "numeric", month: "long", year: "numeric" };
  let s = d.toLocaleDateString("en-GB", opts);
  if (withTime) s += ` · ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`;
  return s;
}
